import { render, staticRenderFns } from "./cancelNewsletterComponent.vue?vue&type=template&id=de42bab2&scoped=true&"
import script from "./cancelNewsletterComponent.vue?vue&type=script&lang=js&"
export * from "./cancelNewsletterComponent.vue?vue&type=script&lang=js&"
import style0 from "./cancelNewsletterComponent.vue?vue&type=style&index=0&id=de42bab2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de42bab2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VContainer})
